import React from "react";
import { useTranslation } from "react-i18next";
import Block from "../../Block";
import FormGroup from "../../forms/FormGroup";
import Select from "../../forms/inputs/Select";

export default function Wifi({ getInputProps, formRefValues, formData }) {
  const { t } = useTranslation();

  return (
    <Block title={t("dataVendor.wifiNetwork")}> 
      <FormGroup
        label={t("dataVendor.wifiNetwork")}
        placeholder={t("pleaseSelect")}
        {...getInputProps("wifi_network_ssids")}
      >
        <Select isMulti name="wifi_network_ssids" creatable />
      </FormGroup>
    </Block>
  );
}
